import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Form,
  Row,
} from 'antd'
import { 
  Link
} from 'react-router-dom'
import { generateInputForm } from '../../util/formGenerator'
import { IconValidate } from '../../components/IconSVG'
import { removeUndefinedProp } from '../../util/helper'
import { USER_ROLE } from '../../util/config'
import styles from './Register.module.scss'
import ReCAPTCHA from 'react-google-recaptcha'
import { error } from 'jquery'
import axios from 'axios'
import ModalTermCondition from './ModalTermCondition'

const regExpContainAlphabet = /[a-zA-Z]+/
const regExpContainNumeric = /[0-9]+/ 

const formItemLayout = {
  colon: false,
  labelAlign: 'left',
  hideRequiredMark: true,
  labelCol: {
    xs: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
  },
}

const ROLE_STUDENT = USER_ROLE.STUDENT
const ROLE_TEACHER = USER_ROLE.TEACHER

const { REACT_APP_RECAPTCHA_SITE_KEY } = process.env

class FormNewCredential extends Component {

  constructor(props) {
    super(props)
    this.recaptcha = React.createRef()
    this.state = {
      isFormDirty: false,
      isPasswordMin6: false,
      isPasswordHaveAlphabet: false,
      isPasswordHaveNumberic: false,
      role: null,
      errorRecaptcha: '',
      isShowTerm: false, // Only show modal after user selects a role
      termsAccepted: false,
      privacyAccepted: false,
      hasSelectedRole: false, // Track if user has made a role selection
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      this.setState({ isFormDirty: true })
      if (!err) {
        const params = {
          ...values,
          role: this.state.role,
        }
        const recaptchaValue = this.recaptcha.current.getValue()
        if (recaptchaValue) {
          this.setState({ errorRecaptcha: '' })
          // verify recaptchaValue
          const res = await axios.post('/auth/recaptcha-verify', {
            recaptchaValue: recaptchaValue
          })

          const { result } = res.data;
          if (result) {
            params.recaptchaValue = recaptchaValue
            removeUndefinedProp(params)
            this.props.onSubmit(params)
            this.recaptcha.current.reset()
          }
          else {
            this.setState({ errorRecaptcha: 'กรุณายืนยันว่าไม่ใช่โปรแกรมอัตโนมัติ' })
          }
        }
        else {
          this.setState({ errorRecaptcha: 'กรุณายืนยันว่าไม่ใช่โปรแกรมอัตโนมัติ' })
        }
      }
    })
  }

  switchRole = (role) => {
    // Always show modal when user clicks on a role button, even if it's the same role
    this.setState({
      role: role,
      isFormDirty: false,
      isShowTerm: true,
      termsAccepted: false,
      privacyAccepted: false,
      hasSelectedRole: true,
    })
    this.props.form.resetFields()
  }

  matchPassword = (rule, value, callback) => {
    if ( value && value !== this.props.form.getFieldValue('password') ) {
      callback('รหัสผ่านยืนยันไม่ตรงกัน')
    }
    callback()
  }

  onChangePassword = (e) => {
    const value = e.target.value
    this.setState({
      isPasswordMin6: (value && value.length >= 6),
      isPasswordHaveAlphabet: value && regExpContainAlphabet.test(value),
      isPasswordHaveNumberic: value && regExpContainNumeric.test(value),
    })
    this.props.form.isFieldsTouched = false
  }

  onTermOK = () => {
    this.setState({
      isShowTerm: false,
      termsAccepted: true,
      privacyAccepted: true,
    })
  }

  onTermCancel = () => {
    this.setState({
      isShowTerm: false,
      termsAccepted: false,
      privacyAccepted: false,
    })
  }

  setPrivacyPolicy = (privacyPolicy) => {
    // This method is required by ModalTermCondition
  }

  render() {
    const { form, termAndCondition, dataPrivacy } = this.props
    const { errorRecaptcha, termsAccepted, privacyAccepted, isShowTerm, role, hasSelectedRole } = this.state
    const{ isPasswordMin6, isPasswordHaveAlphabet, isPasswordHaveNumberic, isFormDirty } = this.state

    const isTeacher = this.state.role === ROLE_TEACHER
    const isStudent = this.state.role === ROLE_STUDENT
    const areTermsAccepted = hasSelectedRole && termsAccepted && privacyAccepted

    // const inputUserName = isTeacher ? null : generateInputForm({ fieldName: 'username', form, label: 'ชื่อผู้ใช้งาน', isRegister: true, isFormDirty, limit: 30, customRules: [
    //   { required: true, message: 'กรุณาใส่ชื่อผู้ใช้งาน' },
    //   { min: 4, message: 'มีอย่างน้อย 4 ตัว' },
    //   { pattern: new RegExp(/^[A-Za-z0-9]+$/), message: 'ชื่อผู้ใช้งาน ต้องเป็นภาษาอังกฤษหรือตัวเลขเท่านั้น'},
    // ], props: {
    //   autoComplete: 'username'
    // } }) 
    const inputEmail = generateInputForm({ fieldName: 'email', form, label: 'อีเมล',isRegister: true, isFormDirty, limit: 254, customRules: [
      { required: true, message: 'กรุณาใส่อีเมล' },
      { type: 'email', message: 'รูปแบบอีเมลไม่ถูกต้อง' }
    ], props: {
      autoComplete: 'username',
      disabled: !areTermsAccepted
    } })
    const inputPassword = generateInputForm({ fieldName: 'password', form, label: 'รหัสผ่าน', isFormDirty, limit: 20,isRegister: true , customRules: [
      { required: true, message: 'กรุณาใส่รหัสผ่าน' },
      { min: 6, message: 'มีอย่างน้อย 6 ตัว' },
      { pattern: new RegExp(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&-_])[A-Za-z\d@$!%*#?&-_]{6,}$/) , message: 'ประกอบด้วยตัวอักษรภาษาอังกฤษและตัวเลข'},
    ], props: {
      type: 'password',
      autoComplete: 'new-password',
      onChange: this.onChangePassword,
      disabled: !areTermsAccepted
    } })
    const inputConfirmPassword = generateInputForm({ fieldName: 'confirm_password', form, label: 'ยืนยันรหัสผ่าน',isRegister: true , isFormDirty, limit: 20, customRules: [
      { required: true, message: 'กรุณายืนยันรหัสผ่าน' },
      { validator: this.matchPassword}
    ], props: {
      type: 'password',
      autoComplete: 'new-password',
      disabled: !areTermsAccepted
    } })

    return (
      <Fragment>
        <div className='flex-space-between login-register' style={{ marginBottom: 15 }}>
          <h2 className={`${styles.formHead} text-medium mb-0`}>สมัครสมาชิก</h2>
          <Link className={`${styles.formLink} text-underline text-thin`} to='/login' >เข้าสู่ระบบ</Link>
        </div>

        <p className='text-medium'>ประเภทผู้ใช้งาน</p>

        <Row type='flex' justify='space-between' style={{ marginBottom: 15 }}>
          <Button id='studentRoleBtn' type={ isStudent ? 'primary' : 'secondary'} className={isStudent ? styles.btnRole : styles.btnRoleSecondary} onClick={() => this.switchRole(ROLE_STUDENT)} >นักเรียน</Button>
          <Button id='teacherRoleBtn' type={ isTeacher ? 'primary' : 'secondary'} className={isTeacher ? styles.btnRole : styles.btnRoleSecondary} onClick={() => this.switchRole(ROLE_TEACHER)} >ครู/อาจารย์</Button>
        </Row>

        <Form {...formItemLayout} onSubmit={this.handleSubmit} >
          {/* {inputUserName} */}
          {inputEmail}
          <p className={`${styles.textValidate} text-thin text-sm`} style = {{marginTop : -10}}>(ระบบจะส่งข้อความให้ยืนยันตัวตนทางอีเมล)</p>
          {inputPassword}
          
          <p className={`${styles.textValidate} text-thin text-sm`} ><IconValidate correct={ isPasswordHaveAlphabet ? 1 : undefined } className={styles.iconValidate} /> ประกอบด้วยตัวอักษรภาษาอังกฤษ</p>
          <p className={`${styles.textValidate} text-thin text-sm`} ><IconValidate correct={ isPasswordHaveNumberic ? 1 : undefined } className={styles.iconValidate} /> ประกอบด้วยตัวเลข</p>
          <p className={`${styles.textValidate} text-thin text-sm`} ><IconValidate correct={ isPasswordMin6 ? 1 : undefined } className={styles.iconValidate} /> มีอย่างน้อย 6 ตัว</p>
          
          {inputConfirmPassword}
          
          {!areTermsAccepted && (
            <div style={{ 
              padding: '15px', 
              backgroundColor: '#f0f0f0', 
              borderRadius: '4px', 
              marginTop: '15px',
              textAlign: 'center',
              color: '#666'
            }}>
              <p className='text-regular'>
                {!hasSelectedRole 
                  ? 'กรุณาเลือกประเภทผู้ใช้งานเพื่อดำเนินการต่อ'
                  : 'กรุณายอมรับข้อตกลงและเงื่อนไขการใช้งาน และนโยบายความเป็นส่วนตัวก่อนดำเนินการต่อ'
                }
              </p>
            </div>
          )}
          
          <ReCAPTCHA 
            sitekey={REACT_APP_RECAPTCHA_SITE_KEY} 
            ref={this.recaptcha} 
            style={{ 
              marginTop: 20,
              opacity: areTermsAccepted ? 1 : 0.5,
              pointerEvents: areTermsAccepted ? 'auto' : 'none'
            }} 
          />
          { errorRecaptcha ? <p className='text-regular text-sm' style={{ color: '#F54B5E'}}>{errorRecaptcha}</p> : '' }

          <span style = {{color: 'red', fontSize: '16px'}}>* จำเป็นต้องกรอก</span>
          <Button 
            id='nextStepRegister' 
            type='primary' 
            htmlType='submit' 
            disabled={!areTermsAccepted}
            style={{ width: '100%', marginTop: 10 }}
          >
            ถัดไป
          </Button>
        </Form>
        
        {termAndCondition && dataPrivacy && role && (
          <ModalTermCondition
            isVisible={isShowTerm}
            onOK={this.onTermOK}
            onCancel={this.onTermCancel}
            role={role}
            termAndCondition={termAndCondition}
            dataPrivacy={dataPrivacy}
            setPrivacyPolicy={this.setPrivacyPolicy}
            fromaddgroup={false}
            saveButtonLabel="ยอมรับและดำเนินการต่อ"
          />
        )}
      </Fragment>
    )
  }
}

FormNewCredential.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  termAndCondition: PropTypes.object,
  dataPrivacy: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
}

const WrappedFormNewCredential = Form.create({ name: 'form_new_credential' })(FormNewCredential)
export default WrappedFormNewCredential